import React, { Component } from 'react';
import Header from './components/Header.js'
import Home from './components/Home.js';
import About from './components/About.js';
import Footer from './components/Footer.js';
import {BrowserRouter  , Route,Switch} from 'react-router-dom';
import './App.css';

class App extends Component {
  render() {
    return (
      <BrowserRouter>
          <div className="lawshram-container">
          <Header/>

              <Switch>
                  <Route exact path="/about" component={About}/>
                  <Route exact path="/:targetId" component={Home}/>
                  <Route path="/" component={Home}/>
              </Switch>
              <Footer/>
          </div>
      </BrowserRouter>
    );
  }
}

export default App;
